import script from "./FoilCutterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FoilCutterForm.vue?vue&type=script&setup=true&lang=js"

import "./FoilCutterForm.vue?vue&type=style&index=0&id=2800e08c&lang=css"

const __exports__ = script;

export default __exports__